import React, { forwardRef } from 'react'
import { styled, TableCell } from '@mui/material'

export const Root = styled(
  forwardRef(({ disableBottomBorder, enableHead, margin, padding, verticalAlign, width, ...props }, ref) => (
    <TableCell {...props} ref={ref} />
  ))
)`
  &.MuiTableCell-root {
    border-bottom: ${props => (props.disableBottomBorder ? 'none' : `1px solid ${props.theme.palette.gray[85]}`)};
    color: ${props => props.theme.palette.gray[20]};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-weight: ${props => (props.enableHead ? 'bold' : 'initial')};
    line-height: 18px;
    margin: ${props => props.margin};
    min-width: ${props => props.width};
    padding: ${props => props.padding};
    vertical-align: ${props => (props.enableHead ? 'top' : props.verticalAlign || 'initial')};
    width: ${props => props.width};

    &:last-child {
      border-right: 0;
    }
  }
`
